<template>
  <main id="app" class="redesign-enabled">
    <router-view />
  </main>
</template>
<script>
import nativeToast from "native-toast";
export default {
  data() {
    return {
      icon: require("../public/flag_en.png"),
      copy: false,
      url: window.location.href,
    };
  },

  watch: {
    "$i18n.locale": {
      immediate: true,

      handler(locale) {
        this.updateDirection(locale);
        this.icon = this.getFlagForLocale(locale);
      },
    },
  },

  methods: {
    updateDirection(locale) {
      const rtlLocales = ["ar"];
      const direction = rtlLocales.includes(locale) ? "rtl" : "ltr";

      document.documentElement.setAttribute("dir", direction);
      document.documentElement.setAttribute("lang", locale);
    },

    getFlagForLocale(locale) {
      const flags = {
        en: require("../public/flag_en.png"),
        es: require("../public/flag_es.png"),
        fr: require("../public/flag_fr.png"),
        de: require("../public/flag_de.png"),
        nl: require("../public/flag_nl.svg"),
        it: require("../public/flag_it.svg"),
        pt: require("../public/flag_pt.png"),
        pl: require("../public/flag_pl.svg"),
        tr: require("../public/flag_tr.svg"),
        id: require("../public/flag_id.svg"),
        ja: require("../public/flag_ja.svg"),
        hi: require("../public/flag_in.svg"),
        ar: require("../public/flag_sa.png"),
        ko: require("../public/flag_kr.svg"),
        "zh-CN": require("../public/flag_cn.svg"),
        uk: require("../public/flag_ua.svg"),
      };

      return flags[locale] || flags.en;
    },

    setLocale(locale) {
      this.$router.push(
        this.$route.name === "home"
          ? { path: `/${locale}` }
          : { params: { ...this.$route.params, lang: locale } }
      );
    },

    clipboardSuccessHandler({ value }) {
      if (navigator.share) {
        navigator
          .share({
            title: this.$t("shareDialogTitle"),
            text: this.$parent.listName + this.$t("shareDialogText"),
            url: window.location.href,
          })
          .then(() => {
            console.log("Thanks for sharing!");
          })
          .catch(err => {
            console.log("Couldn't share because of", err.message);
          });
      } else {
        console.log("web share not supported");
        console.log("success", value);

        nativeToast({
          message: this.$t("linkCopied"),
          position: "north-east",
          // Self destroy in 5 seconds
          timeout: 3000,
          type: "success",
        });
      }
    },
  },
  created() {
    //
  },
};
</script>
<style>
@import "./styles/colors.css";
@import "./styles/redesign-desktop.css";
@import "./styles/redesign-mobile.css";
@import "./styles/information-mobile.css";

/* The list's two-column desktop layout starts above 768px. */
@media (min-width: 769px) {
  #app.redesign-enabled .list .card.first,
  #app.redesign-enabled .list .card.item-area {
    border: 1px solid #dce1e5;
    border-radius: 1.5rem;
    background: #fff;
    box-shadow: 0 12px 40px rgba(35, 50, 65, 0.12) !important;
  }

  #app.redesign-enabled .list .item-area > .card-header {
    border: 0;
    border-radius: 1.5rem;
    background: #fff;
    box-shadow: none;
  }
}

/* body {
    /* background-image: url('../public/background.jpg');
    background-size: cover;
    height: 100%; */
*/ .card-header {
  background: var(--color-white) !important;
}
a {
  color: var(--color-white);
}
a:hover {
  text-decoration: none;
}
.languages {
  color: var(--color-white);
}
.black {
  color: var(--color-black) !important;
}

.btn-info {
  background: var(--color-primary);
}

.btn-info:hover {
  background: var(--color-primary);
}
.card {
  border: 2px solid var(--color-primary);
  box-shadow: 17px 20px 33px -10px rgba(0, 0, 0, 0.2) !important;
  border-radius: 1rem;
}

.navbar-dark .navbar-nav .nav-link {
  color: var(--color-white);
}
.navbar-dark .navbar-toggler {
  color: var(--color-white);
  border-color: var(--color-white);
}
b-nav-item {
  color: var(--color-white) !important;
}
.web-logo {
  /*position: absolute;
      top: 50px;*/
  cursor: pointer;
}

.logo {
  display: none;
}

@media screen and (max-width: 768px) {
  /* .icon {
        visibility: visible;
        
      } */
  body {
    overflow: hidden;
  }

  /* Home pages use document scrolling; list screens retain their internal scrollers.
     Bootstrap's modal scroll lock must still take precedence. */
  body.home-page-scroll:not(.modal-open) {
    overflow: visible;
  }

  .logo {
    display: inline;
    position: absolute;
    top: 0px;
    left: 10px;
  }

  .web-logo {
    display: none;
  }
  .languages a {
    text-align: right;
  }
  .dropdown-menu {
    background-color: rgba(74, 160, 181, 0);
    border: none;
  }
}

@media (min-width: 991px) {
  .navbar-desktop-transparent {
    background-color: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
  }
}

@media screen and (max-width: 768px) {
  .card {
    border: 2px solid var(--color-white);
  }
  body {
    background-size: auto;
  }
}
</style>
